import React from 'react';
import { combineClassNames } from 'core/css';

const DisclaimerContainer = (props) => {
  const {
    analyticsKey,
    analyticsKey2,
    classIdentifier,
    disclaimer,
    notifications,
    children,
    useModal = false,
  } = props;
  const { disabled, show } = notifications;

  if (disabled) {
    return <div>{children}</div>;
  }

  return (
    <div
      className={combineClassNames(
        'disclaimer-container',
        'stat-disclaim',
        classIdentifier && `${classIdentifier}-disclaimer-container`
      )}
      data-dtm={analyticsKey}
      data-dtm2={analyticsKey2}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        useModal
          ? show(disclaimer, event, null, true)
          : show(disclaimer, event);
      }}>
      {children}
    </div>
  );
};

export default DisclaimerContainer;
